import React from "react";
import AnimateLines from "@/components/AnimateLine";
import AdaptiveImage from "@/components/AdaptiveImage";
import EthImage from "@/components/EthImage";

import { fomatDecimal } from "@/utils";
import { AnimateProps } from "../../../types";

import "./index.css";

const Part2: React.FC<AnimateProps> = (props) => {
  const { data } = props;

  return (
    <div className="part_contain part_contain_2">
      <div style={{ flex: 1, width: "100%" }} />
      <div className="part_content">
        <AnimateLines animateType={props.type}>
          <div>
            <span className="text_remind">{data.buy_count} </span>
            <span className="text_content">NFTs of </span>
            <span className="text_remind">{data.buy_collection_count} </span>
            <span className="text_content">collection</span>
          </div>
          <p className="mb_30">
            <span className="text_content">you collected in 2022.</span>
          </p>
          <p>
            <span className="text_content">Total cost</span>&ensp;
            <span className="text_num">
              {fomatDecimal(data.buy_cost)}
            </span>
            <EthImage />
          </p>
          <p className="mb_16">
            <span className="text_content">Total earned</span>&ensp;
            <span className="text_num">
              {fomatDecimal(data.earned)}
            </span>
            <EthImage />
          </p>
          <p>
            <span className="text_content">Cost exceeds</span>&ensp;
            <span className="text_num">
              {(Math.floor(data.buy_cost_ratio * 100) / 100) * 100}%
            </span>&ensp;
            <span className="text_content">traders</span>
          </p>
          <p>
            <span className="text_content">Profit exceeds</span>&ensp;
            <span className="text_num">
              {(Math.floor(data.earned_ratio * 100) / 100) * 100}%
            </span>
            &ensp;
            <span className="text_content">of the world!</span>
          </p>
        </AnimateLines>
      </div>
      <div style={{ flex: 1, width: "100%" }} />
      <AnimateLines animateType={props.type} animateName="animate__fadeIn">
        <div>
          <AdaptiveImage name="Frame101023" />
        </div>
      </AnimateLines>
      <div style={{ flex: 2, width: "100%" }} />
    </div>
  );
};

export default Part2;
